export enum RouteName {
  activityView = '/activity',
  auctionsView = '/auctions',
  home = '/',
  sell = '/sell',
  multipleCollection = '/'
}
